/**
 * @desc 新增
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<defs.appCenter.PageViewResponseDto>;
export function request(body: defs.appCenter.PageViewRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/view/add`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
